import Vue from 'vue';

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Fetch and set the CSRF token for all axios requests.
window.axios.get('/session/token').then(response => {
    window.axios.defaults.headers.common['X-CSRF-Token'] = response.data;
});

window.lodash = require('lodash');

import VShowSlide from "v-show-slide";
Vue.use(VShowSlide);

import VueAccessibleModal from 'vue-accessible-modal';
import 'vue-accessible-modal/dist/index.css';
Vue.use(VueAccessibleModal, {transition: "fade"});

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
Vue.use(PerfectScrollbar, {
    options: {
        'wheelPropagation': false,
        'suppressScrollX': true
    }
});

import Toaster from 'v-toaster';
import 'v-toaster/dist/v-toaster.css';
Vue.use(Toaster, {timeout: 5000});

let googleApiKey = 'AIzaSyBHiicumuHlwSpNy0eyxyg20iHw5fj7uAw';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
    load: {
        key: googleApiKey,
        libraries: 'places',
        region: 'NL',
        language: 'nl'
    }
});

import Geocoder from "@pderas/vue2-geocoder";

Vue.use(Geocoder, {
    defaultCountryCode: 'NL',
    defaultLanguage: 'nl',
    defaultMode: 'address',
    googleMapsApiKey: googleApiKey,

});

import VueFormulate from '@braid/vue-formulate';
import { nl } from '@braid/vue-formulate-i18n';

Vue.use(VueFormulate, {
    plugins: [ nl ],
    locale: 'nl',
    classes: {
        elementHasErrors: 'error'
    }
});

import VueYoutube from "vue-youtube";
Vue.use(VueYoutube);

Vue.component('aut-vehicle-overview', require('./Components/Vehicle/OverviewV2').default);
Vue.component('aut-vehicle-overview-cta', require('./Components/Vehicle/OverviewCta').default);
Vue.component('aut-vehicle-teaser', require('./Components/Vehicle/Teaser').default);
Vue.component('aut-vehicle-widget', require('./Components/VehicleWidget').default);
Vue.component('aut-phone-formatter', require('./Components/PhoneFormatter').default);

Vue.component('aut-location-dropdown', require('./Components/Location/Dropdown').default);

Vue.component('aut-reservation-wrapper', require('./Components/Reservation/Wrapper').default);
Vue.component('aut-reservation-receipt', require('./Components/Reservation/Receipt').default);

Vue.component('aut-rental-option-modal-wrapper', require('./Components/Reservation/ModalWrapper').default);

Vue.component('aut-accordion', require('./Components/Accordion').default);
Vue.component('aut-search-bar-toggle', require('./Components/SearchBarToggle').default);
Vue.component('aut-search-bar', require('./Components/SearchBar').default);

Vue.component('aut-locations-alphabetically', require('./Components/Location/LocationsAlphabetically').default);
Vue.component('aut-location-wrapper', require('./Components/Location/locationWrapper').default);

Vue.component('aut-icon-passenger-car', require('./Components/Svg/IconPassengerCar').default);
Vue.component('aut-icon-delivery-van', require('./Components/Svg/IconDeliveryVan').default);
Vue.component('aut-icon-passenger-bus', require('./Components/Svg/IconPassengerBus').default);
Vue.component('aut-icon-trailer', require('./Components/Svg/IconTrailer').default);
Vue.component('aut-icon-refrigerated-truck', require('./Components/Svg/IconRefrigeratedTruck').default);
Vue.component('aut-icon-other', require('./Components/Svg/IconOther').default);
Vue.component('aut-icon-check', require('./Components/Svg/IconCheck.vue').default);
Vue.component('aut-balloon', require('./Components/Svg/Balloon').default);
Vue.component('aut-icon-ev', require('./Components/Svg/IconEv.vue').default);
Vue.component('aut-icon-electric', require('./Components/Svg/IconElectric.vue').default);
Vue.component('aut-icon-fuel', require('./Components/Svg/IconFuel.vue').default);
Vue.component('aut-icon-transmission', require('./Components/Svg/IconTransmissionManual.vue').default);
Vue.component('aut-icon-seasonal-promotion', require('./Components/Svg/IconSeasonalPromotion.vue').default);
Vue.component('aut-account-button', require('./Components/AccountButton').default);
Vue.component('aut-customer-banner', require('./Components/Customer/DashboardBanner').default);
Vue.component('aut-my-location', require('./Components/Customer/MyLocation').default);
Vue.component('aut-alert', require('./Components/Alert').default);
Vue.component('aut-homepage-modal', require('./Components/HomepageModal').default);
Vue.component('aut-icon-dashboard', require('./Components/Svg/IconDashboard').default);
Vue.component('aut-icon-car', require('./Components/Svg/IconCar').default);
Vue.component('aut-icon-reservations', require('./Components/Svg/IconReservations').default);
Vue.component('aut-icon-account', require('./Components/Svg/IconAccount').default);
Vue.component('aut-icon-logout', require('./Components/Svg/IconLogout').default);
Vue.component('aut-customer-dashboard', require('./Components/Customer/Dashboard').default);
Vue.component('aut-customer-account', require('./Components/Customer/Account').default);

import router from './router.js';
import store from './store.js';

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.doRedirect)) {
        if (!lodash.isEmpty(store.getters.getActiveLocation) || !lodash.isEmpty(store.getters.getActiveVehicle)) {
            next();
        } else {
            next({
                name: to.meta?.isBusiness ? 'stepOneBusiness' : 'stepOne',
                query: {
                    vehicleId: to.query.vehicleId,
                    locationId: to.query.locationId,
                    vehicleWrapperId: to.query.vehicleWrapperId,
                }
            });
        }
    } else {
        next();
    }
});

new Vue({
    'el': '#page-wrapper',

    comments: true,

    data() {
        return {
            searchBarOpen: false,
        }
    },

    methods: {
        handleSearchBarToggle(payload) {
            this.searchBarOpen = payload;
        },
    },

    store,

    router
})
